import {faFilterList} from "@fortawesome/pro-solid-svg-icons/faFilterList";
import {Button, ColourSolid, useLayout} from "@twigsby/frontend-framework";
import {useTranslation} from "@twigsby/frontend-framework";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {MailboxFilterType} from "../../../Types/MailboxProviderTypes";

const MailboxFilter = (props: MailboxFilterType) => {
    const { isTiny } = useLayout();
    const { userFilters, ShowFilters } = useMailbox();
    const { t } = useTranslation();

    return (
        <Button squared={true} colour={ColourSolid.Primary} title={Object.keys(userFilters).length > 0 ? t('actions.filtersCount', { count: Object.keys(userFilters).length }) : t('actions.filters')} icon={faFilterList} iconOnly={isTiny} onClick={() => ShowFilters()}/>
    )
}

export { MailboxFilter }
